import {
    Box,
    Typography,
    Grid
} from '@mui/material'
import ShareIcon from '../../../assets/app/personal-loan/icon_share.png'
import BG from '../../../assets/app/personal-loan/requirements_bg.png'
import { Image } from 'antd'
import { ROOT_PATH } from '../../../common/config'
import { useTranslation } from 'react-i18next'

export const SMAppRequirements: React.FC = () => {

    const { t } = useTranslation()
    
    // 打开新页面
    const openRepaymentChannel = () => {
        window.open(ROOT_PATH + '/repayment-channel')
    }

    const data = [
        {
            'title': t('t222'),
            'data': [
                t('t223'),
                t('t224'),
                t('t225')
            ],
        },
        {
            'title': t('t226'),
            'data': [
                t('t227'),
                t('t228'),
                t('t229')
            ],
        },
        {
            'title': t('t230'),
            'data': [t('t231'),
                t('t232'),
                t('t233')
            ],
        },
        {
            'title': t('t234'),
            'data': [t('t235'),
                t('t236'),
                t('t237')
            ],
        },
    ]

    const data1 = [
        {
            'title': t('t238'),
            'content': t('t239'),
            'icon': ShareIcon
        },
    ]

    const renderItem = (index: number) => {
        return (
            <Grid key={index} item xs={12}>
                <Box sx={{
                    width: '100%',
                    height: '100%',
                    paddingLeft: '12px',
                    paddingRight: '12px',
                }}>
                    <Typography fontSize={20} fontWeight={600} color={'#141F39'}>
                        {data[index]['title']}
                    </Typography>

                    <Box sx={{ paddingTop: '0px' }}>
                        {data[index]['data'].map((subItem, subIndex) => (
                            renderTitleItem(subItem, subIndex)
                        ))}
                    </Box>
                </Box>
            </Grid>
        )
    }

    const renderTitleItem = (item: string, index: number) => {
        return (
            <Box key={index} sx={{
                display: 'flex',
                flexDirection: 'row',
                paddingTop: '4px',
            }}>
                <Box sx={{
                    paddingTop: '7px',
                }}>
                    <Box sx={{
                        width: '6px',
                        height: '6px',
                        borderRadius: '3px',
                        backgroundColor: '#6B6B6B'
                    }}></Box>
                </Box>
                <Typography fontSize={14} fontWeight={400} color={'#6B6B6B'} paddingLeft={'8px'}>
                    {item}
                </Typography>
            </Box>
        )
    }

    const renderItem1 = (index: number) => {
        return (
            <Grid item key={index} xs={12}>
                <Box>
                    <Typography fontSize={16} fontWeight={700} color={'#141F39'} paddingLeft={'12px'} paddingRight={'12px'}>
                        {data1[index]['title']}
                    </Typography>
                    <Box onClick={openRepaymentChannel} sx={{
                        paddingLeft: '12px',
                        paddingRight: '12px',
                        paddingTop: '12px',
                        display: 'flex',
                        flexDirection: 'row'
                    }}>
                        <Image src={data1[index]['icon']} width={24} height={24} alt='' preview={false}></Image>
                        <Box sx={{ flex: '1', paddingLeft: '8px' }}>
                            <Typography fontSize={16} fontWeight={700} color={'#6B6B6B'}>
                                {data1[index]['content']}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Grid>
        )
    }

    // ======================= VIEWS
    return (
        <Box
            sx={{
                width: '100%',
                paddingLeft: '12px',
                paddingRight: '12px',
                paddingTop: '60px',
            }}
        >
            <Image src={BG} alt='' preview={false} width={'100%'}></Image>
            <Typography fontSize={24} fontWeight={700} color={'#141F39'} paddingLeft={'12px'} paddingRight={'12px'} paddingTop={'20px'}>
                {t('t221')}
            </Typography>

            <Grid container rowSpacing={2} paddingTop={'20px'}>
                {data.map((item, index) => (renderItem(index)))}
            </Grid>

            <Box sx={{ height: '16px' }}></Box>

            <Grid container rowSpacing={2}>
                {data1.map((item, index) => (
                    renderItem1(index)
                ))}
            </Grid>

            <Box sx={{
                paddingTop: '40px',
                paddingLeft: '12px',
                paddingRight: '12px',
            }}>
                <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'}>
                    {t('t240')}
                </Typography>
            </Box>
        </Box >
    )
}

// ======================= EXPORT
export default SMAppRequirements
